import { VEHICLE_LIST_FILTER_NAME } from 'Components/VehicleList/VehicleListFilters.consts';
import { useMakes } from 'Stores/MakesStore/MakesStore';
import { FILTERS_DISPLAY_CONFIG } from 'Stores/SavedFiltersStore/SavedFilters.conf';
import { getModelsValues } from 'Stores/SavedFiltersStore/SavedFilters.helpers';

import useGetSelectedModelsAndMakesHandler from './models/useGetSelectedMakesAndModelsHandler';

const makeConfig = FILTERS_DISPLAY_CONFIG.get(VEHICLE_LIST_FILTER_NAME.MAKE);
const modelConfig = FILTERS_DISPLAY_CONFIG.get(VEHICLE_LIST_FILTER_NAME.MODEL);

const useSavedFiltersDisplayOrder = () => {
	const makes = useMakes();

	makeConfig.makes = makes;
	FILTERS_DISPLAY_CONFIG.set(VEHICLE_LIST_FILTER_NAME.MAKE, makeConfig);

	modelConfig.renderFn = useGetSelectedModelsAndMakesHandler(getModelsValues);
	FILTERS_DISPLAY_CONFIG.set(VEHICLE_LIST_FILTER_NAME.MODEL, modelConfig);

	return FILTERS_DISPLAY_CONFIG;
};

export default useSavedFiltersDisplayOrder;
